export const ComponentHeader = (props) => (
  <div className="flex justify-between h-[40px] text-2xl shadow-[2px_4px_14px_0px_rgba(0,0,0,0.1)] text-black px-[22px] relative z-[1]">
    <div className="font-['Montserrat'] font-bold uppercase text-[14px] items-center flex">
      {props.text}
    </div>
    {props.children && <div>{props.children}</div>}
  </div>
);
